import { FC } from 'react';

import { Curtain, CurtainProps } from '../components/Curtain';
import { useErrorMessage } from '../hooks/useErrorMessage';

export interface ErrorCurtainProps extends Omit<CurtainProps, 'act'> {
  error?: unknown;
}

export const ErrorCurtain: FC<ErrorCurtainProps> = ({ error, ...rest }) => {
  const { title, message: text } = useErrorMessage(error) ?? {};

  return <Curtain act="error" title={title} text={text} {...rest} />;
};
